import React from "react";
import Layout from "@/components/Layout";
import { ScrollFade, HeroStaggerText } from "@/lib/animations";

export default function RefundPolicy() {
  return (
    <Layout>
      <section className="bg-[#163A2F] text-[#F8F6F0] grain relative pt-20 pb-16 md:pt-28 md:pb-20 overflow-hidden">
        <div className="relative z-10 max-w-[1440px] mx-auto px-6 md:px-12 lg:px-24">
          <div className="overline text-[#C9A227]">Legal</div>
          <HeroStaggerText
            text="Refund & Return Policy"
            className="mt-3 text-4xl md:text-6xl font-extralight tracking-tight"
          />
          <p className="mt-4 text-[#F8F6F0]/70 font-light text-sm tracking-wider">Last updated: 10 February 2026</p>
        </div>
      </section>

      <section className="bg-[#F8F6F0] py-16 md:py-20" data-testid="refund-policy-page">
        <div className="max-w-3xl mx-auto px-6 md:px-10 text-[#163A2F] font-light leading-relaxed space-y-8">
          <ScrollFade>
            <p>
              Every Norbu jacket is inspected by hand before dispatch. If something is still not right, we will make it right. This policy explains how.
            </p>
          </ScrollFade>

          <ScrollFade>
            <h2 className="text-xl md:text-2xl font-normal text-[#163A2F]">1. Return window</h2>
            <p className="mt-3 text-[#163A2F]/85">
              You may request a return or exchange within <strong>7 days of delivery</strong>. Requests raised after 7 days cannot be processed.
            </p>
          </ScrollFade>

          <ScrollFade>
            <h2 className="text-xl md:text-2xl font-normal text-[#163A2F]">2. Eligibility</h2>
            <ul className="mt-3 list-disc pl-5 space-y-2 text-[#163A2F]/85">
              <li>The product must be unworn, unwashed and in original condition.</li>
              <li>All original tags, packaging and the invoice must be intact.</li>
              <li>Products marked "Final Sale" or purchased with a promotional coupon over 25% off are not eligible for return (exchange only for size).</li>
              <li>Innerwear and face masks (if any) cannot be returned for hygiene reasons.</li>
            </ul>
          </ScrollFade>

          <ScrollFade>
            <h2 className="text-xl md:text-2xl font-normal text-[#163A2F]">3. How to raise a return</h2>
            <ol className="mt-3 list-decimal pl-5 space-y-2 text-[#163A2F]/85">
              <li>Email <a href="mailto:support.norbucollection@gmail.com" className="text-[#C9A227] underline">support.norbucollection@gmail.com</a> or WhatsApp <a href="https://wa.me/919560995329" className="text-[#C9A227] underline">+91 95609 95329</a> with your order ID and reason.</li>
              <li>Our team will approve the return within 24–48 business hours.</li>
              <li>We will arrange a reverse pickup via Shiprocket wherever your pincode is serviceable. Otherwise, you may self-ship to our Delhi studio and we will reimburse standard courier charges.</li>
            </ol>
          </ScrollFade>

          <ScrollFade>
            <h2 className="text-xl md:text-2xl font-normal text-[#163A2F]">4. Refunds</h2>
            <ul className="mt-3 list-disc pl-5 space-y-2 text-[#163A2F]/85">
              <li>Once we receive and inspect the returned product (within 2–3 business days), we initiate the refund.</li>
              <li>Refunds are credited back to the <strong>original payment method</strong> within 5–7 business days.</li>
              <li>Prepaid orders: full refund including shipping charges (if any).</li>
              <li>Cash-on-Delivery orders: refunds are issued to the bank account you share with us.</li>
              <li>Shipping charges on returns of change-of-mind orders are non-refundable.</li>
            </ul>
          </ScrollFade>

          <ScrollFade>
            <h2 className="text-xl md:text-2xl font-normal text-[#163A2F]">5. Exchanges</h2>
            <p className="mt-3 text-[#163A2F]/85">
              Need a different size or colour? We offer one free exchange per order, subject to stock. The replacement is shipped as soon as we receive and clear the original item.
            </p>
          </ScrollFade>

          <ScrollFade>
            <h2 className="text-xl md:text-2xl font-normal text-[#163A2F]">6. Damaged, defective or wrong items</h2>
            <p className="mt-3 text-[#163A2F]/85">
              If you receive a product that is damaged in transit, defective or different from what you ordered, contact us within <strong>48 hours of delivery</strong> with photos. We will arrange a free pickup and offer a full replacement or 100% refund — your choice.
            </p>
          </ScrollFade>

          <ScrollFade>
            <h2 className="text-xl md:text-2xl font-normal text-[#163A2F]">7. Order cancellation</h2>
            <p className="mt-3 text-[#163A2F]/85">
              Orders can be cancelled free of charge any time before dispatch. Once dispatched, the order will be treated as a return. Prepaid refunds for cancellations are credited within 5–7 business days.
            </p>
          </ScrollFade>

          <ScrollFade>
            <h2 className="text-xl md:text-2xl font-normal text-[#163A2F]">8. Contact</h2>
            <p className="mt-3 text-[#163A2F]/85">
              Email: <a href="mailto:support.norbucollection@gmail.com" className="text-[#C9A227] underline">support.norbucollection@gmail.com</a><br />
              WhatsApp / Phone: +91 95609 95329<br />
              Support hours: Mon – Sat, 10:00 to 19:00 IST.
            </p>
          </ScrollFade>
        </div>
      </section>
    </Layout>
  );
}
